<script setup lang="ts">
import { ref, onMounted, onUnmounted } from "vue";
import { useRoute } from "vue-router";
import BrandLogo from "../components/BrandLogo.vue";
import ResultView from "../components/ResultView.vue";
import { errorText, dateTime } from "../api";
const route = useRoute(),
  data = ref<any>(),
  error = ref(""),
  loading = ref(true);
async function load() {
  loading.value = true;
  error.value = "";
  try {
    const response = await fetch(
      `/api/public/views/${encodeURIComponent(String(route.params.org))}/${encodeURIComponent(String(route.params.token))}`,
      { credentials: "omit" },
    );
    const value = await response.json();
    if (!response.ok) throw Error(value.message);
    data.value = value;
    document.title = value.name + " · Yawhub";
  } catch (e) {
    data.value = undefined;
    error.value = errorText(e);
  } finally {
    loading.value = false;
  }
}
onMounted(load);
onUnmounted(() => {
  document.title = "Yawhub";
});
</script>
<template>
  <main class="public-view">
    <header>
      <a href="/" aria-label="Yawhub" class="brand"><BrandLogo /></a
      ><span class="muted small">Delt kort · læseadgang</span>
    </header>
    <p v-if="loading" role="status">Henter kortet…</p>
    <div v-else-if="error" class="empty-state">
      <h1>Kortet er ikke tilgængeligt</h1>
      <p role="alert">{{ error }}</p>
      <button class="button secondary" @click="load">Prøv igen</button>
    </div>
    <template v-else-if="data"
      ><div class="section-heading">
        <div>
          <h1>{{ data.name }}</h1>
          <p class="muted">
            Opdateret {{ dateTime(data.result.metadata.executedAt) }}
          </p>
        </div>
        <button class="button secondary" @click="load">Opdatér</button>
      </div>
      <ResultView
        :result="data.result"
        :page-url="`/api/public/views/${encodeURIComponent(String(route.params.org))}/${encodeURIComponent(String(route.params.token))}`"
        public-page
        :kind="data.kind"
        :field-ids="data.config.fieldIds"
        :scale-bars="data.config.scaleBars"
        :show-updated-at="data.config.showUpdatedAt"
      />
      <p v-if="data.limited" class="muted small">
        Viser de første {{ data.result.rows.length }} rækker fra det gemte
        kort.
      </p>
    </template>
  </main>
</template>
<style scoped lang="scss" src="../styles/pages/PublicView.scss"></style>
